const worlds = [
  'artistic',
  'scientific',
  'social_ethic',
  'societal',
  'spiritual'
];

export default worlds;
